export const toInputDate = (value) => {
  if (!value) return "";

  const date = String(value).split("T")[0];

  if (date === "1900-01-01") return "";

  return date;
};

export const formatDateDDMMYYYY = (date) => {

  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");

  const month = String(
    d.getMonth() + 1
  ).padStart(2, "0");

  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

export const formatTime = (timeValue) => {

  if (!timeValue) return "";

  const timePart =
    timeValue.split("T")[1]
      .substring(0, 5);

  const [hours, minutes] =
    timePart.split(":");

  const date = new Date();

  date.setHours(hours);
  date.setMinutes(minutes);

  return date.toLocaleTimeString(
    "en-IN",
    {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }
  );
};

export const formatSlotTime = (slotTime) => {
  if (!slotTime) return "Not selected";

  const date = new Date(slotTime);

  if (Number.isNaN(date.getTime())) return slotTime;

  return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
  });
};